import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * ScrollIndicator
 *
 * The ScrollIndicator only shows itself if the duration is greater than its CSS appear + hide transition time
 * It can be unmounted softly, letting the CSS hide transition apply, calling its `unmount` function
 *
 * @param  {number} duration - The scroll duration in seconds
 * @param  {number} direction (1:down)|(-1:up) - The scroll direction
 * @param  {number} transitionDuration - The transition duration per slide in seconds, should match the CSS transition time of the component
 * @param  {onUnmount} onUnmount - A callback function tu unmount the component
 * @return {React.Component}
 */

class ScrollIndicator extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.durationMS = this.props.duration * 1000;
    this.transitionDurationMS = this.props.transitionDuration * 1000;
    this.start = new Date();
    this.timer = null;

    /** Refs */
    this.element = React.createRef();
    this.indicator = React.createRef();
  }

  /**
   * Invoked after the component is mounted
   */
  componentDidMount() {
    /** Show the indicator only if the scroll duration is greater than its CSS appear + hide transition time */
    if (this.props.duration > this.props.transitionDuration * 2) {
      this.element.current.classList.add('is-visible');

      /** Rotate the indicator */
      this.timer = setInterval(() => {
        const now = new Date();
        const elapsed = now - this.start;
        this.indicator.current.style.transform = `rotate(${this.props.direction * 360 * (elapsed / this.durationMS)}deg)`;
      }, 10);
    }
  }

  /**
   * Public function to unmount the component, letting the CSS transition apply
   */
  unmount() {
    clearInterval(this.timer);
    this.element.current.classList.remove('is-visible');
    setTimeout(() => {
      this.props.onUnmount();
    }, this.transitionDurationMS);
  }

  render() {
    return (
      <div ref={this.element} className="scroll-indicator">
        <span ref={this.indicator} />
      </div>
    );
  }
}

ScrollIndicator.propTypes = {
  duration: PropTypes.number.isRequired,
  direction: PropTypes.number.isRequired,
  transitionDuration: PropTypes.number.isRequired,
  onUnmount: PropTypes.func.isRequired,
};

export default ScrollIndicator;
